import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';

import { FileUtil } from 'rev-shared/util/FileUtil';
import { FileWrapper } from 'rev-shared/ui/fileUpload/FileWrapper';
import { IUnsubscribe } from 'rev-shared/push/IUnsubscribe';
import { PushBus } from 'rev-shared/push/PushBus.Service';

import { EditWebcastModel } from './EditWebcastModel';
import { EditWebcastBaseSettingsComponent } from './EditWebcastBaseSettings.Component';
import { EditWebcastService } from './EditWebcast.Service';
import { IProducerBgImage } from '../webcast/model/WebcastModel';

import styles from './EditWebcastProducerSettings.module.less';

@Component({
	selector: 'edit-webcast-producer-settings',
	templateUrl: './EditWebcastProducerSettings.Component.html',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => EditWebcastProducerSettingsComponent),
		multi: true,
	}],
	standalone: false
})
export class EditWebcastProducerSettingsComponent extends EditWebcastBaseSettingsComponent implements OnInit, OnDestroy {
	@Input() public webcast: EditWebcastModel;

	public readonly styles = styles;
	public readonly imgExtensions = FileUtil.jpgPngAccept;
	public readonly maxBgImages = 25;
	private processingFiles = 0;
	private invalidFileType: boolean;
	private sub: IUnsubscribe;

	constructor(
		private readonly EditWebcastService: EditWebcastService,
		private readonly PushBus: PushBus
	) {
		super();
	}

	public ngOnInit(): void {
		if(this.webcast.id) {
			this.sub = this.PushBus.subscribe(this.webcast.id, {
				'ImageInstancesAdded': img => {
					this.webcast.producerBgImages = this.webcast.producerBgImages
						.map(oldImg => oldImg.id === img.id ? img : oldImg);
				}
			});
		}
	}

	public ngOnDestroy(): void {
		this.sub?.();
	}

	public canAddBg(): boolean {
		return this.webcast.producerBgImages.length + this.processingFiles < this.maxBgImages;
	}

	public addBgImage(file: FileWrapper): void {
		if(!this.canAddBg()) {
			return;
		}

		this.invalidFileType = !FileUtil.isJpgPngFile(file.extension);
		if(this.invalidFileType) {
			return;
		}

		this.processingFiles++;
		this.EditWebcastService.uploadProducerBgImage(this.webcast, file)
			.catch(e => console.error('error adding producer bg image: ', e))
			.finally(() => this.processingFiles--);
	}

	public removeBgImage(img: any): void {
		this.webcast.producerBgImages = this.webcast.producerBgImages.filter(i => i !== img);
	}

	public getThumbnail(img: IProducerBgImage): string {
		const url = img.extraSmall || img.small || img.original;
		return url ? `url(${url})` : '';
	}

	public isLoading(img: IProducerBgImage): boolean {
		return !(img.extraSmall || img.small || img.original);
	}
}
